<a [routerLink]="'/level/' + _level.levelId" *ngIf="_level">
  <level-avatar [level]="_level" size="h-5 w-5 mr-1"></level-avatar>
  <span>{{(_level.title.length > 0) ? _level.title : "Unnamed Level"}}</span>
</a>
